import { FC } from "react";
import FormInput from "../FormInput";
import useFormsStore from "../../store/formValuesStore";
import { useTranslation } from "react-i18next";

const ThirdForm: FC = () => {
  const { values, setValue } = useFormsStore();
  const handleChange = (value: string) => {
    setValue(3, value);
  };

  const { t } = useTranslation();

  return (
    <div>
      <FormInput
        value={values[3].value}
        onChangeText={handleChange}
        label={t("questions.4")}
      />
    </div>
  );
};

export default ThirdForm;
